/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconBrandGravatar = createReactComponent("brand-gravatar", "IconBrandGravatar", [
  ["path", { d: "M5.64 5.632a9 9 0 1 0 6.36 -2.632v7.714", key: "svg-0" }]
]);

export { IconBrandGravatar as default };
//# sourceMappingURL=IconBrandGravatar.js.map
